export default [
    {
        path: '/user/profile-update-success',
        name: 'profile-update-success',
        component: () => import('@/pages/User/ProfileUpdateSuccess.vue'),
    },

]